import { IMPERSONATOR_USER_ID_STORAGE_KEY } from './constants';

/** Clear the stored admin id when an impersonation ends, guarded so a throwing storage is a no-op. */
export const removeImpersonatorUserId = (): void => {
  try {
    globalThis.localStorage.removeItem(IMPERSONATOR_USER_ID_STORAGE_KEY);
  } catch {
    // Nothing to recover from.
  }
};
